export { BrandingForm } from './BrandingForm';

// BoxyHQ branding
export const boxyhqBranding = {
  logoUrl: '/logo.png',
  faviconUrl: '/favicon.ico',
  companyName: 'BoxyHQ',
  primaryColor: '#25c2a0',
};
